/* eslint-disable no-param-reassign */
import { ACTION_TYPE, GETTER_TYPE, MUTATION_TYPE } from './types'
import notsApi from '@/api/notifications'

export default {
  state: {
    nots: [],
    latestNots: [],
    currentPage: 1,
    perPage: 10,
    unreadNots: 0,
    totalNots: 0
  },
  mutations: {
    [MUTATION_TYPE.setNots]: (state, nots) => {
      if (state.currentPage > 1) {
        state.nots = state.nots.slice(0, (state.currentPage - 1) * state.perPage)
        nots.forEach((el) => state.nots.push(el))
      } else {
        state.nots = nots
      }
    },
    [MUTATION_TYPE.setUnreadNots]: (state, nots) => {
      state.unreadNots = nots
    },
    [MUTATION_TYPE.setLatestNots]: (state, nots) => {
      state.latestNots = nots
    },
    [MUTATION_TYPE.setCurrentPage]: (state, num) => {
      state.currentPage = num
    },
    [MUTATION_TYPE.setTotalNots]: (state, total) => {
      state.totalNots = total
    },
    [MUTATION_TYPE.clearNots]: (state) => {
      state.nots = []
    }
  },
  actions: {
    [ACTION_TYPE.fetchNots]: ({ commit, state }) => new Promise((resolve, reject) => {
      notsApi.getNotes(state.perPage, state.currentPage).then(({ data }) => {
        commit(MUTATION_TYPE.setNots, data.docs)
        commit(MUTATION_TYPE.setTotalNots, data.total)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    }),
    [ACTION_TYPE.fetchLatestNots]: ({ commit }) => new Promise((resolve, reject) => {
      notsApi.getNotes(10, 1).then(({ data }) => {
        commit(MUTATION_TYPE.setLatestNots, data.docs)
        commit(MUTATION_TYPE.setTotalNots, data.total)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    }),
    [ACTION_TYPE.fetchUnreadNots]: ({ commit }) => new Promise((resolve, reject) => {
      notsApi.getUnreadNotes().then(({ data }) => {
        commit(MUTATION_TYPE.setUnreadNots, data)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    }),
    [ACTION_TYPE.changePage]: ({ commit }, page) => {
      commit(MUTATION_TYPE.setCurrentPage, page)
    },
    [ACTION_TYPE.clearNots]: ({ commit }) => {
      commit(MUTATION_TYPE.clearNots)
    }
  },
  getters: {
    [GETTER_TYPE.getNots]: (state) => state.nots,
    [GETTER_TYPE.getUnreadNots]: (state) => state.unreadNots,
    [GETTER_TYPE.getLatestNots]: (state) => state.latestNots,
    [GETTER_TYPE.getCurrentPage]: (state) => state.currentPage,
    [GETTER_TYPE.getPerPage]: (state) => state.perPage,
    [GETTER_TYPE.getTotal]: (state) => state.totalNots
  }
}
